<template>
  <div :id="id" class="autofit">
    <slot />
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import autofit from 'autofit.js'

/**
 * 大屏等比自适应容器（复刻 forestry-compre-pc 的 components/autoFit.vue）。
 * autofit.js 的做法：把 el 撑到「视口尺寸 / 缩放比」的设计像素，再整体
 * transform: scale —— 统一缩放、锚定左上、无黑边无变形，面板永远贴满四边。
 * ⚠️ 槽内所有尺寸必须写固定设计像素（1920×1080 基准）：
 *    vw/vh 和视口媒体查询在缩放子树里都指向真实视口，会算错，一律不要用。
 * 只包 UI 覆盖层：三维画布不进容器，保持全屏真实分辨率。
 */
const props = defineProps({
  id: { type: String, default: 'autofit' },
  dw: { type: Number, default: 1920 },
  dh: { type: Number, default: 1080 },
})

let instance = null

onMounted(() => {
  // autofit.js 的 el 参数是选择器字符串，不是 DOM 元素
  instance = autofit.init({ el: `#${props.id}`, dw: props.dw, dh: props.dh }, false)
})

onBeforeUnmount(() => {
  instance?.off()
})
</script>

<style scoped>
.autofit {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 100;
}
</style>
